import ItemService from "../services/commonService";
import Constants from "./Constants";

export const REVISING_REPORT_TYPES = Object.freeze(
  Object.fromEntries(
    Constants.MASTER.REVISING_NUMBER.REPORT_TYPES.map((option) => [
      option.value,
      option.value,
    ]),
  ),
);

export const loadSizeMasterByCode = async (jobcards = []) => {
  const sizeCodes = [
    ...new Set(jobcards.map((item) => item?.sizeCode).filter(Boolean)),
  ];

  const sizeEntries = await Promise.all(
    sizeCodes.map(async (sizeCode) => {
      const response = await ItemService.getMasterListDataById({
        url: "getSizeById",
        sizeCode,
      });

      return [sizeCode, response?.status === 200 ? response?.data : null];
    }),
  );

  return Object.fromEntries(sizeEntries.filter(([, size]) => size));
};

export const getReportTitleParts = (sizeMasterByCode, sizeCode) => {
  const reportTitle = sizeMasterByCode?.[sizeCode]?.reportTitle;

  return typeof reportTitle === "string"
    ? reportTitle.split(",").map((part) => part.trim())
    : [];
};

export const loadJobcardRevisingMetadata = async (
  jobcards = [],
  reportType,
) => {
  const jobcardCodes = [
    ...new Set(
      jobcards
        .map((item) => (typeof item === "string" ? item : item?.jobcard))
        .filter(Boolean),
    ),
  ];
  const response = await ItemService.getTransactionListDataById({
    url: "getJobcardRevisingMetadata",
    jobcards: jobcardCodes,
    reportType,
  });
  const records = response?.status === 200 ? response?.data?.jobcards || [] : [];

  return {
    byJobcard: Object.fromEntries(
      records
        .filter((item) => item?.jobcard)
        .map((item) => [item.jobcard, item]),
    ),
    fallback:
      response?.status === 200
        ? response?.data?.fallback || {}
        : {},
  };
};

export const resolveJobcardRevisingSnapshot = (
  revisingMetadata = {},
  jobcard,
) => {
  const jobcardData = revisingMetadata?.byJobcard?.[jobcard] || {};
  const reviseNumber =
    jobcardData.latestRevisingNumber || jobcardData.reviseNumber || "";
  const reviseDate = jobcardData.latestRevisingDate || "";

  if (reviseNumber) {
    return { reviseNumber, reviseDate };
  }

  return {
    reviseNumber: revisingMetadata?.fallback?.latestRevisingNumber || "",
    reviseDate: revisingMetadata?.fallback?.latestRevisingDate || "",
  };
};

export const getJobcardReportFooter = ({
  sizeMasterByCode = {},
  sizeCode,
  jobcard,
  revisingMetadata = {},
  fixedReportTitle = "",
}) => {
  const [sizeReportTitle = ""] = getReportTitleParts(
    sizeMasterByCode,
    sizeCode,
  );
  const revision = resolveJobcardRevisingSnapshot(
    revisingMetadata,
    jobcard,
  );

  return {
    reportTitle: fixedReportTitle || sizeReportTitle,
    reviseNumber: revision.reviseNumber,
    reviseDate: revision.reviseDate,
  };
};
